import { Controller } from 'react-hook-form';

import SearchTextField from 'Components/SeachTextField/SearchTextField';
import CustomSelect from 'Components/CustomSelect/CustomSelect';
import type { HistoryCoursesFilterI } from 'types';
import { Search } from '@mui/icons-material';
import useHistoryCoursesFilters from 'Hooks/useHistoryCoursesFilters';
import {
  ReportsLayoutFiltersContainer,
  ResetButton,
  SearchButton,
} from '../HistoryReportFilters/HistoryReportFilters.styled';
import useTranslation from 'Hooks/useTranslation';

interface Props {
  onSearch: (filters: HistoryCoursesFilterI) => void;
}

const HistoryCoursesFilters = ({ onSearch }: Props) => {
  const { control, isDirty, handleReset, getFiltersForApi, prioritiesData, categoriesData } = useHistoryCoursesFilters({
    onSearch,
  });

  const { t2 } = useTranslation('history_courses_report');

  return (
    <ReportsLayoutFiltersContainer>
      <Controller
        name="name"
        control={control}
        render={({ field }) => <SearchTextField placeholder={t2('course_name_placeholder')} {...field} />}
      />

      <Controller
        name="priorityId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('priority_placeholder')}
            options={prioritiesData?.map(priority => ({
              value: priority.id,
              label: priority.name,
            }))}
            {...field}
          />
        )}
      />

      <Controller
        name="categoryId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('category_placeholder')}
            options={categoriesData?.map(category => ({
              value: category.id,
              label: category.name,
            }))}
            {...field}
          />
        )}
      />

      <SearchButton
        variant="outlined"
        color="success"
        hidden={!isDirty}
        startIcon={<Search />}
        onClick={() => {
          const values = getFiltersForApi();
          onSearch(values);
        }}
      >
        {t2('search')}
      </SearchButton>

      {isDirty && (
        <ResetButton onClick={handleReset} variant="outlined">
          {t2('clear_filters')}
        </ResetButton>
      )}
    </ReportsLayoutFiltersContainer>
  );
};

export default HistoryCoursesFilters;
